export default {
    routes: [
        {
            path: 'drive/:docPath(.*)*',
            name: 'drive',
            component: () => import('@/pages/organization/drive/Index.vue'),
            props: true
        }
    ],
    nav: () => ({
        section: 'global',
        items: [
            {
                position: 2,
                title: i18n.t('Files'),
                icon: 'folder-multiple-outline',
                to: { name: 'drive' }
            }
        ]
    })
};
